export default __webpack_public_path__ + "static/media/calendar.e5048986.svg";